import React, {useMemo} from 'react'
import logoLong from 'images/logo-long.png'
import logoIcon from 'images/logo-icon.png'
import logoLongContrast from 'images/logo-long-contrast.png'
import logoIconContrast from 'images/logo-icon-contrast.png'
import { withStyles } from '@material-ui/styles';
import PropTypes from 'prop-types'
import { ListItem, Tooltip } from '@material-ui/core';
import clsx from 'clsx';
import RouterPath from 'libs/RouterPath';
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import Tr from 'translations/Translations';
import Endpoints from "constants/Endpoints";

const style = theme => ({
	root: {
		height: theme.spacing(6),
	},
	image: {
		objectFit: 'contain',
	},
	imageOpen: {
		width: theme.components.navigation.width - theme.spacing(8),
		marginLeft: theme.spacing(2)
	},
	imageClose: {
		width: theme.spacing(3) + 1,
	}
})

function Logo({
	open,
	purchaser,
	classes,
	isContrast
}) {

	const logoLongMem = useMemo(()=> isContrast ? logoLongContrast : logoLong, [isContrast])
	const logoIconMem = useMemo(()=> isContrast ? logoIconContrast : logoIcon, [isContrast])

	const handleDashboardRedirect = () => {
		window.location.href = Endpoints.SERVER_URL;
	}

	return (
		<ListItem
			className={classes.root}
		>
			<Tooltip title={Tr('main_menu')}>
				<Link to={RouterPath.BASE} onClick={handleDashboardRedirect}>
					<img
						className={clsx(classes.image, {
							[classes.imageOpen]: open,
							[classes.imageClose]: !open
						})}
						src={open ? logoLongMem : logoIconMem}
						alt={Tr('ezam')}
					/>
				</Link>
			</ Tooltip>
		</ListItem >
	)
}

Logo.propTypes = {
	open: PropTypes.bool,
}

Logo.defaultProps = {
	open: false,
}


export default connect((state) => ({
	isContrast: state.store.contrast,
}), {

})(withStyles(style)(Logo));